import React from "react";

/* Dark "Coming soon" badges with the real App Store + Google Play logos */

export const APP_STORE_URL =
  "https://apps.apple.com/il/app/coly-gut-companion/id6776822586";
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.colyapp.app";

export const AppBadges = () => (
  <div className="flex flex-nowrap sm:flex-wrap gap-2 sm:gap-3 items-stretch w-full sm:w-auto" data-testid="app-badges">
    <Badge
      label="App Store"
      sub="Download on the"
      icon={<AppleLogo />}
      href={APP_STORE_URL}
      testId="app-badge-apple"
    />
    <Badge
      label="Google Play"
      sub="Get it on"
      icon={<GooglePlayLogo />}
      href={GOOGLE_PLAY_URL}
      testId="app-badge-google"
    />
  </div>
);

const Badge = ({ label, sub, icon, href, testId }) => {
  const inner = (
    <>
      <div className="w-6 h-6 sm:w-9 sm:h-9 flex items-center justify-center shrink-0">{icon}</div>
      <div className="flex flex-col leading-tight min-w-0 flex-1">
        <span className="text-[8.5px] sm:text-[10px] font-extrabold tracking-[1px] sm:tracking-[1.4px] uppercase text-coly-green">
          Available now
        </span>
        <span className="hidden sm:inline text-[10px] font-semibold text-coly-dark-text/65 mt-0.5 truncate">{sub}</span>
        <span className="text-[12px] sm:text-[16px] font-extrabold text-coly-dark-text mt-px truncate">{label}</span>
      </div>
      <svg
        className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-coly-dark-text/60 shrink-0 ml-1 -mr-0.5 transition-transform group-hover:translate-x-0.5"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M7 17L17 7" />
        <path d="M8 7h9v9" />
      </svg>
    </>
  );

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className="group inline-flex items-center gap-1.5 sm:gap-3 bg-coly-dark text-coly-dark-text pl-2 sm:pl-3.5 pr-2 sm:pr-4 py-2 sm:py-2.5 rounded-xl sm:rounded-2xl border-[1.5px] border-white/[0.08] flex-1 sm:flex-none sm:min-w-[220px] min-w-0 cursor-pointer transition-all hover:-translate-y-0.5 hover:border-coly-green/50 hover:shadow-[0_10px_30px_-10px_rgba(63,117,86,0.5)]"
    >
      {inner}
    </a>
  );
};

/* Authentic Apple logo */
const AppleLogo = () => (
  <svg className="w-5 h-5 sm:w-[26px] sm:h-[26px]" viewBox="0 0 24 24" fill="#F0E8DC">
    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
  </svg>
);

/* Real Google Play logo — the official 4-color origami-folded play button */
const GooglePlayLogo = () => (
  <svg className="w-[18px] h-[20px] sm:w-[22px] sm:h-[24px]" viewBox="0 0 60 67" xmlns="http://www.w3.org/2000/svg">
    {/* Blue back panel */}
    <path
      d="M0.69 0.69C0.25 1.13 0 1.81 0 2.69v61.62c0 0.88 0.25 1.56 0.69 2L31.5 33.5 0.69 0.69z"
      fill="#00C3FF"
    />
    {/* Green top half (folds forward) */}
    <path
      d="M40.06 24.06 3 0.38C2.69 0.19 2.38 0.13 2.06 0.13 1.5 0.13 1.06 0.31 0.69 0.69L31.5 33.5 40.06 24.06z"
      fill="#00E676"
    />
    {/* Red bottom half */}
    <path
      d="M0.69 66.31C1.06 66.69 1.5 66.88 2.06 66.88c0.31 0 0.63-0.06 0.94-0.25L40.06 42.94 31.5 33.5 0.69 66.31z"
      fill="#FF3D00"
    />
    {/* Yellow right-tip triangle */}
    <path
      d="M40.06 24.06 31.5 33.5 40.06 42.94 53.06 35.56c1.69-0.94 1.69-3.19 0-4.19L40.06 24.06z"
      fill="#FFD600"
    />
  </svg>
);

export default AppBadges;
